/** macOS shows Cmd where everyone else sees Ctrl ("mod" in shortcut notation). */
export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  const platform = uaData?.platform ?? navigator.platform ?? '';
  return /mac|iphone|ipad/i.test(platform);
}
